"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberFormatterBoolean = void 0;
const React = require("react");
const react_1 = require("react");
class NumberFormatterBoolean extends react_1.Component {
    constructor(props) {
        super(props);
        // method working as a callable to update the value in the parent component
        this.invokeParentMethod = () => {
            this.props.context.componentParent.booleanMethodFromParent(this.props.value);
        };
        this.invokeParentMethod = this.invokeParentMethod.bind(this);
    }
    render() {
        // Account for blank rows during row grouping
        if (this.props.value ||
            this.props.value === 0 ||
            this.props.value === false) {
            const { value } = this.props;
            const checked = !!value;
            return (React.createElement("span", null,
                React.createElement("input", { type: "checkbox", value: this.props.value, onChange: this.invokeParentMethod, checked: checked })));
        }
        return React.createElement("span", null);
    }
}
exports.NumberFormatterBoolean = NumberFormatterBoolean;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/claim-analytics/number-formatter-boolean.tsx
// module id = 3559
// module chunks = 0